import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { toast, Toaster } from 'react-hot-toast';

const Email = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(process.env.REACT_APP_Service_Id, process.env.REACT_APP_Template_Id, form.current, process.env.REACT_APP_Public_Key)
            .then((result) => {
                console.log(result.text);
                toast.success('Email sent')
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div className='p-3 md:p-5 md:w-1/2 rounded-xl mx-auto md:mb-10 email'>
            <h1 className='text-3xl font-bold my-5'>Send me a email</h1>
            <form ref={form} onSubmit={sendEmail}>
                <div className='mb-3'>
                    <label className='text-lg font-semibold'>Name</label>
                    <input type="text" name="user_name" className='block mx-auto p-2 rounded-lg w-full md:w-96 mt-2' />
                </div>
                <div className='mb-3'>
                    <label className='text-lg font-semibold'>Email</label>
                    <input type="email" name="user_email" className='block mx-auto p-2 rounded-lg w-full md:w-96 mt-2' />
                </div>
                <div className='mb-3'>
                    <label className='text-lg font-semibold'>Subject</label>
                    <input type="text" name="email_subject" className='block mx-auto p-2 rounded-lg w-full md:w-96 mt-2' />
                </div>
                <div className='mb-3'>
                    <label className='text-lg font-semibold'>Message</label>
                    <textarea name="message" className='block mx-auto p-2 rounded-lg w-full md:w-96 mt-2' />
                </div>
                <div className='mb-3'>
                    <input type="submit" value="Send" className='text-lg font-semibold shadow-md px-4 py-2 rounded-md mt-3' />
                </div>
            </form>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
        </div>
    );
};

export default Email;